import { graphql } from "~/gql";

export const UPDATE_CLIENT = graphql(/* GraphQL */ `
  mutation updateClient($id: Int!, $data: ClientUpdateInput!) {
    updateClient(id: $id, data: $data) {
      id
      name
      externalReference
      excludeTax
    }
  }
`);
